module.exports = __webpack_public_path__ + "img/bttn_AR_Cox.55526ca4.png";